import React, { useEffect, useState } from 'react';
import MainLayout from 'layout/MainLayout';
import useClient from 'hooks/useClient';
import { RiseLoader } from 'react-spinners';
import { useTheme } from 'components/common/ThemeContext';
import AnalyticCard from 'components/AnalyticCard';
import moment from 'moment';

const History = () => {
  const [loader, setLoader] = useState(false);
  const [analyticData, setAnalyticData] = useState({});
  const [users, setUsers] = useState([]);
  const { api } = useClient();
  const { theme } = useTheme();

  const handleAnalytic = () => {
    setLoader(true);
    api
      .get(`/auth/get-stats`)
      .then((res) => {
        setAnalyticData(res?.data || {});
        setLoader(false);
      })
      .catch((err) => {
        console.error('Error fetching analytics:', err);
        setLoader(false);
      });
  };

  const fetchUser = () => {
    setLoader(true);
    api
      .get('/auth/get-all-users')
      .then((res) => {
        const { data } = res;
        setUsers(data?.users || []);
        setLoader(false);
      })
      .catch((err) => {
        console.error('Error fetching users:', err);
        setLoader(false);
      });
  };

  useEffect(() => {
    fetchUser();
    handleAnalytic();
  }, []);

  return (
    <MainLayout>
      {loader && (
        <div className="mt-[100px] flex justify-center">
          <RiseLoader color={theme === 'dark' ? '#ffffff' : '#000'} size={36} />
        </div>
      )}
      {!loader && (
        <>
          {/* Analytics Cards */}
          <div className="grid xs:grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5 p-4">
            <div className="col-span-1">
              <AnalyticCard
                index={1}
                title="Total Registered Users"
                value={`${analyticData?.total_registered_users || 0}`}
              />
            </div>
            <div className="col-span-1">
              <AnalyticCard
                index={2}
                title="Average Subtasks"
                value={`${analyticData?.average_subtasks || 0}`}
              />
            </div>
            <div className="col-span-1">
              <AnalyticCard
                index={3}
                title="Average Time Taken"
                value={`${analyticData?.average_time_taken || 0} Secs`}
              />
            </div>
            <div className="col-span-1">
              <AnalyticCard
                index={4}
                title="Average Success Rates"
                value={`${analyticData?.average_success_rate || 0}%`}
              />
            </div>
          </div>

          {/* Users Table */}
   
          <div className="m-4 bg-[#FFF] dark:bg-[#0F0F0F] p-1 rounded-[5px] overflow-x-auto">
  <table className="w-full rounded-[5px] border-collapse border border-gray-200">
    <thead className="bg-gray-100 dark:bg-[#1A1A1A]">
      <tr>
        <th className="border border-gray-300 px-4 py-2 text-left font-Inter text-sm dark:text-white">
          User
        </th>
        <th className="border border-gray-300 px-4 py-2 text-left font-Inter text-sm dark:text-white">
          Prompt
        </th>
        <th className="border border-gray-300 px-4 py-2 text-left font-Inter text-sm dark:text-white">
          Email
        </th>
        <th className="border border-gray-300 px-4 py-2 text-left font-Inter text-sm dark:text-white">
          Date
        </th>
        <th className="border border-gray-300 px-4 py-2 text-left font-Inter text-sm dark:text-white">
          Status
        </th>
      </tr>
    </thead>
    <tbody>
      {users.length > 0 ? (
        users.map((user, index) => (
          <tr
            key={index}
            className="hover:bg-gray-50 dark:hover:bg-[#1E1E1E]"
          >
            <td className="border border-gray-300 px-4 py-2 text-sm dark:text-white">
              {user?.username || 'Unknown'}
            </td>
            <td className="border border-gray-300 px-4 py-2 text-sm dark:text-white">
              {user?.last_query_logs?.user_query || 'N/A'}
            </td>
            <td className="border border-gray-300 px-4 py-2 text-sm dark:text-white">
              {user?.email || 'N/A'}
            </td>
            <td className="border border-gray-300 px-4 py-2 text-sm dark:text-white">
              {user?.last_query_logs?.created_at
                ? moment(user.last_query_logs.created_at).format(
                    'MMMM DD, YYYY'
                  )
                : 'N/A'}
            </td>
            <td className="border capitalize border-gray-300 px-4 py-2 text-sm dark:text-white">
              <span
                className={`px-3 py-1 rounded-full font-Inter text-white ${
                  user?.last_query_logs?.task_status === 'success'
                    ? 'bg-green-500'
                    : 'bg-red-500'
                }`}
              >
                {user?.last_query_logs?.task_status || 'Failed'}
              </span>
            </td>
          </tr>
        ))
      ) : (
        <tr>
          <td
            colSpan="5"
            className="text-center px-4 py-2 text-sm dark:text-white"
          >
            No Data Available
          </td>
        </tr>
      )}
    </tbody>
  </table>
</div>

         
        </>
      )}
    </MainLayout>
  );
};

export default History;
